export default "__VITE_ASSET__ClwPd0f5__"